"use client";

import { c as _c } from "react/compiler-runtime";
type DividerProps = {
  text?: string;
  className?: string;
};
export default function Divider(t0) {
  const $ = _c(7);
  const {
    text: t1,
    className: t2
  } = t0;
  const text = t1 === undefined ? "\u0B85\u0B9F\u0BC1\u0BA4\u0BCD\u0BA4 \u0B95\u0BA4\u0BC8" : t1;
  const className = t2 === undefined ? "" : t2;
  const t3 = `flex items-center w-full p-4 gap-4 md:gap-6 ${className}`;
  let t4;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="flex-1 h-[4px] bg-012061 opacity-30" />;
    $[0] = t4;
  } else {
    t4 = $[0];
  }
  let t5;
  if ($[1] !== text) {
    t5 = <span className="text-012061 md:text-16-tamil-700 text-24-tamil-700 whitespace-nowrap">{text}</span>;
    $[1] = text;
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  let t6;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="flex-1 h-[4px] bg-012061 opacity-30" />;
    $[3] = t6;
  } else {
    t6 = $[3];
  }
  let t7;
  if ($[4] !== t3 || $[5] !== t5) {
    t7 = <div className={t3}>{t4}{t5}{t6}</div>;
    $[4] = t3;
    $[5] = t5;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  return t7;
}